import { createSlice, createAsyncThunk, createSelector, nanoid } from "@reduxjs/toolkit";
import { getEvents } from "../api/content";


/* Normalize API -> UI fields */
const normalize = (arr, req) =>
  (Array.isArray(arr) ? arr : []).map((e) => ({
    id: e.id || nanoid(),
    city: e.city ?? e.type ?? req?.city ?? null,   
    state: e.state ?? req?.state ?? null,
    business: e.business ?? e.topic ?? null,
    business_id: e.business_id ?? null,
    ffrom: e.from ?? e.ffrom ?? null,
    tto:   e.to   ?? e.tto   ?? null,
    topic: e.topic ?? null,
    description: e.description ?? e.text ?? null,
    link: e.link ?? null,
    image: e.image ?? null,
    video: e.video ?? null,
  }));

export const fetchEvents = createAsyncThunk("events/fetchAll",
  async (request, { rejectWithValue }) => {
    try {
      const raw = await getEvents(request); 
      console.log("Raw", raw)
      return raw;                       
    } catch (err) {
      return rejectWithValue(err?.message || String(err));
    }
  }
);


const initialState = {
  items: [],
  status: "idle",        // idle | loading | succeeded | failed
  error: null,
};

const eventsSlice = createSlice({
  name: "events",
  initialState,
  reducers: {
    setEvents(state, action) {
      state.items = Array.isArray(action.payload) ? action.payload : [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEvents.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchEvents.fulfilled, (state, action) => {
      const items = Array.isArray(action.payload) ? action.payload : (action.payload?.items ?? []);
      state.items = action.payload; 
      state.status = 'succeeded';
      state.error = null;
      })
      .addCase(fetchEvents.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || action.error?.message || "Failed to load events";
      });
  },
});


export const { setEvents } = eventsSlice.actions;
export default eventsSlice.reducer;

/* ---------- Selectors ---------- */
const base = (state) =>
  state?.events ||            // mounted as 'events' (recommended)
  state?.event  ||            // legacy shape
  state?.content ||           // if you mounted it under 'content'
  { items: [] };

export const selectEventsStatus = (s) => base(s).status || "idle";
export const selectEventsError  = (s) => base(s).error || null;
export const selectAllEvents = createSelector([base], (slice) => {
  if (Array.isArray(slice?.items)) return slice.items;
  if (Array.isArray(slice)) return slice;
  if (slice && typeof slice === "object") return Object.values(slice);
  return [];
});